import { __assign } from 'tslib';
import React__default, { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

var TreeAutocomplete = function (_a) {
    var forceSelection = _a.forceSelection, autocompleteOptions = _a.autocompleteOptions, onAutocomplete = _a.onAutocomplete, onBlur = _a.onBlur, multiple = _a.multiple, selectedOptions = _a.selectedOptions, setSelectedOptions = _a.setSelectedOptions, handleSelectOption = _a.handleSelectOption, error = _a.error, helperText = _a.helperText, invertColors = _a.invertColors, inputId = _a.inputId;
    var t = useTranslation("refront-components").t;
    var _b = useState(-1), candidateId = _b[0], setCandidateId = _b[1];
    var _c = useState(), thesaurusCandidatErrorMsg = _c[0], setThesaurusCandidatErrorMsg = _c[1];
    return (React__default.createElement(Autocomplete, { id: inputId, multiple: multiple, freeSolo: !forceSelection, selectOnFocus: true, clearOnBlur: true, handleHomeEndKeys: true, noOptionsText: "", value: multiple ? selectedOptions : selectedOptions[0], ChipProps: __assign({}, (!multiple && {
            deleteIcon: React__default.createElement(React__default.Fragment, null)
        })), onChange: function (_e, _value, reason, details) {
            if (reason === "clear") {
                setSelectedOptions([]);
            }
            else if ((reason === "removeOption" || reason === "selectOption") && details) {
                handleSelectOption(details.option);
            }
            else if (reason === "createOption" && details) {
                if (/[#<>"]/.test(details.option.toString())) {
                    setThesaurusCandidatErrorMsg(t("components.tree-field.notValid.label"));
                }
                else if (details.option.toString().length > 100) {
                    setThesaurusCandidatErrorMsg(t("components.tree-field.notValid.label"));
                }
                else {
                    setThesaurusCandidatErrorMsg(undefined);
                    var candidate = {
                        id: candidateId,
                        label: details.option.toString()
                    };
                    handleSelectOption(candidate);
                    setCandidateId(candidateId - 1);
                }
            }
        }, onInputChange: function (_e, value) {
            if (value && value.length !== 1) {
                onAutocomplete(value);
            }
        }, renderInput: function (params) {
            return (React__default.createElement(TextField, __assign({}, params, { fullWidth: true, size: "small", autoComplete: "off", sx: __assign(__assign({}, (invertColors && { background: "white" })), { borderRadius: function (theme) { return theme.spacing(0.5); } }), error: error || !!thesaurusCandidatErrorMsg, helperText: helperText || thesaurusCandidatErrorMsg, onBlur: onBlur })));
        }, options: autocompleteOptions || [] }));
};

export { TreeAutocomplete };
//# sourceMappingURL=index.js.map
